const module = {
  routes: [
    {
      path: '/global-search',
      component: () => import('@/modules/globalSearch/pages/index.vue'),
      children: [],
      meta: {
        layout: 'default',
        requiresAuth: true
      }
    }
  ]
};

export default module;
